// useOsmSource.ts
import { useEffect, useMemo, useState } from "react";
import olOSMSource from "ol/source/OSM";
import { Theme } from "../../context/theme";
import { OSMGreyscaleDark } from "../reactOL/source";

const attributions = ["© OpenStreetMap contributors", "© Basemap"];

export function useOsmSource(theme: Theme) {
  const lightOsm = useMemo(
    () =>
      new olOSMSource({
        attributions: attributions,
      }),
    [],
  );

  const [osm, setOsm] = useState(lightOsm);

  useEffect(() => {
    setOsm(theme === Theme.DARK ? OSMGreyscaleDark(attributions) : lightOsm);
  }, [theme, lightOsm]);

  return osm;
}
